import BaseService from './baseService';

class AdService {
    static getAdvert(adType, textOnly = false) {
        const windowWidth = $(window).width();
        const responsiveState = parseInt($('.responsive-state').css('width'));
        return BaseService.getAndReturn(`/AdContent?contentType=${adType}&screenWidth=${windowWidth}&responsiveState=${responsiveState}&textOnly=${textOnly}`, BaseService.returnAssignedObject, null, false);
    }

}

export default AdService;
